import type { AxiosError } from 'axios'
import i18n from '@/i18n/i18n'

interface ApiErrorBody {
  title?: string
  detail?: string
  error?: string
  code?: string
}

/**
 * Extracts a human-readable error message from an Axios error response.
 * Checks `detail` first (specific), then `title` (general), then `error` (legacy),
 * then falls back to the Axios message or the provided fallback string.
 */
export function extractApiErrorMessage(
  err: unknown,
  fallback = i18n.t('error.unexpected')
): string {
  if (!err) return fallback
  const axiosErr = err as AxiosError<ApiErrorBody>
  const data = axiosErr?.response?.data
  if (data?.detail) return data.detail
  if (data?.title) return data.title
  if (data?.error) return data.error
  if (axiosErr?.message) return axiosErr.message
  return fallback
}

/** Machine-readable error code from the API body, used to pick a localized message. */
export function extractApiErrorCode(err: unknown): string | undefined {
  return (err as AxiosError<ApiErrorBody>)?.response?.data?.code
}

export function extractApiErrorStatus(err: unknown): number | undefined {
  return (err as AxiosError<ApiErrorBody>)?.response?.status
}
